// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"b0830c06","455":"2c1d140b","977":"3df0da24"}[chunkId] + ".chunk.js";
};